import { createSelector } from '@reduxjs/toolkit';
import { useAppStateSelector } from '@src/providers/AppStateProvider';
import type { AppState } from '@src/providers/AppStateProvider/types';
import { portfolioViewLayoutSliceActions } from './portfolioViewLayoutSlice';

export const selectPortfolioFlexState = createSelector(
  (state: AppState) => state.portfolioViewLayout,
  portfolioFlexState => {
    const { viewState, ...result } = portfolioFlexState;
    return result;
  }
);
export const usePortfolioViewRouteStateSelector = () => {
  return useAppStateSelector(selectPortfolioFlexState);
};

/** retrieve view state from app-level redux */
export const usePortfolioViewStateSelector = () => {
  return useAppStateSelector((state: AppState) => state.portfolioViewLayout.viewState);
};

export function getPortfolioViewActions(): typeof portfolioViewLayoutSliceActions {
  return portfolioViewLayoutSliceActions;
}
